jQuery(function ($) {
    'use strict';

    const selectors = {
        modalContainer: '.min-modal-container',
        closeModal    : '.js-close-min-modal',
        cartButton    : '.js-cart-button',
        overlay       : '.modal-overlay',
        productItem   : '.product-card__img'
    };

    $(selectors.cartButton).on('click', function (e) {
        e.preventDefault();
        showMinOrderModal();
    });

    $(selectors.overlay + ',' + selectors.closeModal).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(selectors.modalContainer).fadeOut();
        $(selectors.modalContainer).removeClass('min-active');
        $(selectors.overlay).fadeOut();
        $(selectors.cartButton).focus();
    });

    function showMinOrderModal() {
        $(selectors.overlay).first()
                            .fadeIn();

        $(selectors.modalContainer).first()
                                   .fadeIn();

        $(selectors.closeModal).focus();
    }
});
